
document.addEventListener('alpine:init', () => {
  Alpine.data('quiz', (questions) => {
    let form = null;
    let $form = null;
    const totalQuestions = questions.length;

    const qId = Array(totalQuestions)
      .fill()
      .map((v, i) => `q${i + 1}`);

    return {
      ...qId.reduce((acc, curr) => ((acc[curr] = ''), acc), {}),
      alpineThis: null,
      activeIndex: 0,
      answered: Array(totalQuestions).fill(false),
      score: 0,
      progressStyle: 'width: 0',
      completionPercentage: 0,
      isAnswered: false,
      _errorMsg: '',
      _loading: false,
      _canNext: false,

      init() {
        form = document.getElementById('quiz');
        $form = $(form);

        this.alpineThis = this;
      },
      loading(isLoading = true) {
        this._loading = isLoading;
      },
      error(errorMessage, errorObject = null) {
        this._errorMsg = errorMessage;
        console.error(errorObject);
      },
      _next() {
        (this.activeIndex += 1), totalQuestions;
        this.isAnswered = this.alpineThis[`q${this.activeIndex + 1}`] !== '';
        this.setProgress();
        this.scrollTop();
        this.setFocus();
      },
      next() {
        const newIndex = this.activeIndex + 1;
        this._next();

        if (newIndex === totalQuestions) {
          this.setScore();
        }
      },
      setAnswer() {
        this[`q${this.activeIndex + 1}`] = true;
        this.isAnswered = true;
      },
      prev() {
        this.activeIndex = Math.max(this.activeIndex - 1, 0);
        this.isAnswered = true;
        this.setProgress();

        this.scrollTop();
      },
      scrollTop() {
        $('html, body').animate(
          {
            scrollTop: $form.offset().top - $('#header').outerHeight(),
          },
          150,
        );
      },
      setProgress() {
        this.completionPercentage = Math.round(
          (this.activeIndex / totalQuestions) * 100,
        );
        this.progressStyle = `width: ${this.completionPercentage}%`;
      },
      setFocus() {
        $form.find('.quiz__question:visible legend').focus();
      },

      setScore() {
        this.score = form.querySelectorAll(
          'input[data-js-correct]:checked',
        ).length;
      },
      submit() {},
    };
  });
});
